<template>
  <div class="container">
    <div class="header">
      <div class="header-body">
        <div class="left">
          <div class="course-name">{{ chapterInfo.title }}</div>
        </div>
        <div class="right">
          <el-dropdown
            hide-on-click
            placement="bottom-end"
            size="medium"
            trigger="click"
            @command="userMenuClick"
          >
            <div class="listed">
              <div :style="{ color: textColor }">
                <img alt="" :src="$store.state.userInfo.headpic" />
                <div>
                  <div class="nickname">
                    {{ $store.state.userInfo.nickname }}
                  </div>
                  <div>{{ $store.state.userInfo.phone_hide }}</div>
                </div>
              </div>
            </div>
            <!-- 下拉选择框 -->
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in userMenu"
                :key="index"
                :command="index"
              >
                <span>{{ item.name }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="pager">
      <div v-if="chapterInfo" class="pager-body">
        <div class="left">
          <template v-if="chapterInfo.live_state == 2">
            <div class="player-box box-relative">
              <video
                :id="playerOption.playerId"
                ref="player"
                class="player-container"
                playsinline="true"
                webkit-playsinline="true"
                x5-playsinline="true"
              />
              <div
                v-if="playerOption.errorMessage != ''"
                class="error-message box-absolute"
              >
                <div class="box-absolute">
                  {{ playerOption.errorMessage }}
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div v-show="chapterInfo.live_state == 0" class="wait">
              <div>
                <div class="jieshutxt">课程未开放</div>
              </div>
            </div>
            <div v-show="chapterInfo.live_state == 1" class="wait">
              <div class="daojishi">距开课时间：{{ waitDaojishi }}</div>
            </div>
            <div v-show="chapterInfo.live_state == 3" class="wait">
              <div>
                <div class="jieshutxt">课程已结束</div>
                <!-- <button class="huifang">学习回放</button> -->
              </div>
            </div>
          </template>
        </div>
        <div class="right">
          <el-tabs
            v-model="tabCurrentKey"
            class="tabs"
            :stretch="true"
            @tab-click="tabChange"
          >
            <el-tab-pane
              v-for="(tab, index) in tabList"
              :key="index"
              :label="tab.name"
              :name="tab.key"
            />
          </el-tabs>

          <div class="main">
            <div class="main-body">
              <div v-show="tabCurrentKey == 'jianjie'" class="jianjie">
                <div
                  v-if="courseDetails"
                  class="content"
                  v-html="courseDetails.content"
                ></div>
              </div>
              <div
                v-show="tabCurrentKey.indexOf('chat_') === 0"
                class="chatbox"
              >
                <div v-if="wslink_state == 0" class="error-msg">
                  建立连接...
                </div>
                <div v-else-if="wslink_state == 2" class="error-msg">
                  连接已断开，<span
                    style="color: #0e79ff"
                    @click="createWsConnect"
                    >重新连接</span
                  >
                </div>
                <div v-else-if="wslink_state == 3" class="error-msg">
                  建立连接出错，<text
                    style="color: #0e79ff"
                    @click="createWsConnect"
                    >点此重试</text
                  >
                </div>

                <template v-else>
                  <div
                    v-for="(chat, chat_k) in live_chats"
                    v-show="tabCurrentChat == chat.id"
                    :key="chat_k"
                    class="wsmsg-box-out"
                  >
                    <div
                      :id="'wsmsg-box-' + chat.id"
                      class="wsmsg-box"
                      :data-chat_id="chat.id"
                      :scroll-top="chat.scrollTop"
                      :scroll-y="true"
                    >
                      <div
                        :id="'wsmsg-list-' + chat.id"
                        class="wsmsg-list"
                        @scroll="wsmsgOnScroll(chat.id)"
                      >
                        <div v-show="chat.name" class="wsok-msg">
                          {{ chat.name }}
                        </div>
                        <div
                          v-for="(item, index) in chat.msgList"
                          :key="index"
                          class="item"
                          :class="item.is_mine == 1 ? 'r' : 'l'"
                        >
                          <el-image
                            class="head"
                            fit="cover"
                            :src="item.headpic"
                          />
                          <div class="body">
                            <div class="name">{{ item.nickname }}</div>
                            <div class="content">
                              <div v-html="item.comment"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="chat.newNumber > 0"
                      class="new-msg-num"
                      @click="wsmsgScrollToBottom(chat.id)"
                    >
                      <div>{{ chat.newNumber }}条新消息</div>
                    </div>
                  </div>

                  <div class="send-box">
                    <el-input
                      v-model="sendCommentContent"
                      class="send-input"
                      placeholder="请文明发言"
                      @keyup.enter.native="sendCommentDo"
                    />
                    <el-button class="send-btn" @click="sendCommentDo"
                      >发送</el-button
                    >
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="copyright">
          <div class="copytext">
            <span
              ><a href="https://beian.miit.gov.cn/" target="_blank"
                >鲁ICP备20006512号-20</a
              ></span
            >
            <span
              >增值电信业务经营许可证：
              <a
                href="https://tsm.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%25E9%25B2%2581B2-20220133&type=xuke"
                target="_blank"
                >鲁B2-20200644</a
              ></span
            >
            <span>山东小白教育科技有限公司/或其关联公司及特许人版权所有</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSubjectDetails } from '@/network/request'
import { postStudyLearn } from '@/network/request'
import { getSectionWithChapter } from '@/api/course'

export default {
  name: 'CourseChapterLive',
  props: {},
  data() {
    return {
      userMenu: [
        {
          name: '退出',
          path: this.logout,
        },
      ],

      //父组件保留字段
      course_id: this.$route.params.course_id, // 传过来的课程id
      chapter_id: this.$route.params.chapter_id, // 传过来的小节id
      courseDetails: null,
      chapterInfo: null,

      timestamp: this.$common.timestampSeconds(),
      Player: null,
      playerOption: {
        playerId: 'player-container-openlive-player',
        autoplay: true,
        errorMessage: '',
      },
      playStartSec: 0, // 开始播放时的秒数（开始时当前时间 - start_time）
      playingSec: 0,
      playingTimer: null,

      tabList: [],
      tabCurrentKey: 'chat_0',
      tabCurrentChat: 0,

      live_state: 0, // 0 未知  1 未开课  2 直播中  3 直播结束

      wslink_state: 0, // 0 连接中， 1 已连接， 2 已断开，3 出错
      live_user_id: 0,
      live_chats: [], // 会话
      live_chats_map: {},
      sendCommentContent: '', // 互动输入框内容
    }
  },
  computed: {
    // 换算单位
    size() {
      return (i) => {
        const kb = i / 1024
        if (kb < 1024) {
          return `${Math.round(kb)} KB`
        } else {
          return `${Math.round(kb / 1024)} MB`
        }
      }
    },
    waitDaojishi() {
      let s = this.chapterInfo.start_time - this.timestamp
      if (s <= 0) {
        return ''
      }
      if (s >= 86400) {
        return (
          Math.floor(s / 86400) + '天' + Math.floor((s % 86400) / 3600) + '小时'
        )
      } else if (s >= 3600) {
        return (
          Math.floor(s / 3600) + '小时' + Math.floor((s % 3600) / 60) + '分钟'
        )
      } else {
        let mm = Math.floor(s / 60)
        let ss = Math.floor(s % 60)
        mm = mm < 10 ? '0' + String(mm) : mm
        ss = ss < 10 ? '0' + String(ss) : ss
        return mm + '分' + ss + '秒'
      }
    },
  },
  watch: {
    tabCurrentKey(e) {
      console.info(e)
      // this.tabCurrentChat = this.tabList[index].chat_id || 0
    },
    // timestamp(e){
    // 	let s = this.chapterInfo.start_time - e
    // 	if(s == 0){
    // 		// 开始直播
    // 		this.live_state = 2
    // 	}
    // },
    // live_state(e) {
    //   console.info('直播状态更改：' + e)
    // },

    // playingSec(e) {
    //   console.info(e)
    //   console.info(this.Player.currentTime())
    // },
  },
  async mounted() {
    console.info(this.course_id)
    await this.$store.dispatch('setUser')
    if (this.$store.state.userInfo) {
      await this.getCourseDetails()
      await this.getChapterInfo()

      setInterval(() => {
        this.timestamp = this.$common.timestampSeconds()
        if (this.Player && !this.Player.paused()) {
          this.playingSec += 1
        }
      }, 1000)

      this.createWsConnect()
    } else {
      alert('未登录')
    }
  },
  beforeDestroy() {
    this.playerDispose()
  },
  methods: {
    tabChange(tab) {
      this.tabCurrentChat = this.tabList[tab.index].chat_id || 0
    },
    async getCourseDetails() {
      const res = await getSubjectDetails(this.course_id, true)
      this.courseDetails = res.data.result
      console.info(this.courseDetails)
    },
    //获取大纲、小节、课件文件、视频信息
    async getChapterInfo() {
      const { data } = await getSectionWithChapter({
        course_id: this.course_id,
      })
      let sectionList = data.result || []
      // 选中小节
      sectionList.some((el) => {
        this.chapterInfo = el.chapters.find((ch) => ch.id == this.chapter_id)
        return true
      })

      // 渲染播放器
      this.$nextTick(() => {
        if (this.chapterInfo.live_state == 2) {
          this.playerInitLive()
        }
      })
    },
    // 初始化选项卡
    initTabList() {
      this.tabList = [
        {
          key: 'jianjie',
          name: '简介',
        },
        {
          key: 'chat_0',
          name: '互动',
          chat_id: 0,
        },
        {
          key: 'kejian',
          name: '课件',
        },
      ]
    },
    // 创建ws连接
    createWsConnect() {
      this.initTabList()
      this.wslink_state = 0
      let linkId = '9:' + this.chapterInfo.period_chapter_id
      console.info(linkId)
      this.$sockets.createConnect(
        linkId,
        {
          live_id: this.chapterInfo.period_chapter_id,
          identity: 'user',
        },
        (data) => {
          data = data ? JSON.parse(data) : null
          console.info(data)
          if (data) {
            switch (data.type) {
              case 1: {
                let chat_id = data.live_chat_id
                data.is_mine = data.live_user_id == this.live_user_id ? 1 : 0

                let listEl = document.getElementById('wsmsg-list-' + chat_id)
                let top =
                  Math.ceil(listEl.scrollHeight - listEl.clientHeight) - 15
                console.info(top, listEl.scrollTop)
                let is_bottom = top <= 0 ? true : listEl.scrollTop > top
                this.pushCommentMsg(data, is_bottom)
                break
              }
              case 2: {
                // 2 为直播流状态推送
                this.playerDispose()
                this.chapterInfo = null
                this.getChapterInfo()
                break
              }
              case 10: {
                // 10 为链接相关通知
                // 告知用户身份id， 和会话列表·
                if (data.code == 201) {
                  this.live_user_id = data.param.live_user_id

                  let live_chats_map = {}
                  data.param.live_chats.forEach((chat, chat_k) => {
                    chat.msgList = []
                    chat.newNumber = 0
                    chat.scrollTop = 0
                    live_chats_map[chat.id] = chat_k
                  })
                  this.live_chats = data.param.live_chats
                  this.live_chats_map = live_chats_map

                  const tabList = []
                  this.tabList.forEach((i) => {
                    if (i.key.indexOf('chat_') === 0) {
                      data.param.live_chats.forEach((chat, chat_k) => {
                        let name = chat_k == 0 ? '互动' : '老师'
                        tabList.push({
                          key: 'chat_' + chat.id,
                          name: name,
                          chat_id: chat.id,
                        })
                      })
                    } else {
                      tabList.push(i)
                    }
                  })
                  this.tabList = tabList
                }
                break
              }
            }
          }
        },
        () => {
          this.wslink_state = 1
        },
        () => {
          this.wslink_state = 2
        },
        () => {
          this.wslink_state = 3
        }
      )
    },
    // 消息列表滚动事件
    wsmsgOnScroll(chat_id) {
      console.info(chat_id)
      let listEl = document.getElementById('wsmsg-list-' + chat_id)
      let chatIndex = this.live_chats_map[chat_id]
      this.live_chats[chatIndex].scrollTop = listEl.scrollTop
      let top = Math.ceil(listEl.scrollHeight - listEl.clientHeight) - 15
      if (this.live_chats[chatIndex].newNumber > 0 && listEl.scrollTop >= top) {
        this.live_chats[chatIndex].newNumber = 0
      }
    },
    // 向列表追加消息
    pushCommentMsg(msg, scroll = false) {
      let chat_id = msg.live_chat_id
      let chatIndex = this.live_chats_map[chat_id]
      let listlen = this.live_chats[chatIndex].msgList.push(msg)
      // 滚动到底部
      this.$nextTick(() => {
        if (scroll) {
          this.wsmsgScrollToBottom(chat_id)
        } else {
          // 不滚动到底部 追加新消息标签
          this.live_chats[chatIndex].newNumber += 1
        }
      })
      let index = listlen - 1
      return index
    },
    // 消息列表滚动到底部
    wsmsgScrollToBottom(chat_id) {
      let listEl = document.getElementById('wsmsg-list-' + chat_id)
      let targetTop = listEl.scrollHeight
      listEl.scrollTo({
        left: 0,
        top: targetTop,
        behavior: 'smooth',
      })
      let chatIndex = this.live_chats_map[chat_id]
      this.live_chats[chatIndex].scrollTop = top
      this.live_chats[chatIndex].newNumber = 0
    },

    // 发送互动消息
    sendCommentDo() {
      let content = this.sendCommentContent.trim()
      if (!content) {
        this.sendCommentContent = ''
        return false
      }
      // 追加消息
      let timestamp = this.timestamp
      this.pushCommentMsg(
        {
          comment: content,
          create_time: timestamp,
          create_time_str: '',
          headpic: this.$store.state.userInfo.headpic,
          nickname: this.$store.state.userInfo.nickname,
          id: 0,
          live_user_id: this.live_user_id,
          live_chat_id: this.tabCurrentChat,
          is_mine: 1,
        },
        true
      )
      // 提交发送并更新消息信息
      let linkId = '9:' + this.chapterInfo.period_chapter_id
      let data = {
        action: 'send',
        params: {
          comment: content,
          chat_id: this.tabCurrentChat,
        },
      }
      this.$sockets.send(linkId, JSON.stringify(data), () => {
        console.info('发送消息：' + content)
      })
      this.sendCommentContent = ''
    },

    // 初始化播放器
    playerInitLive() {
      // 设置播放器
      let sources = [
        {
          src: this.chapterInfo.live_play_url, // 播放地址
        },
      ]
      this.Player = window.TCPlayer(this.playerOption.playerId, {
        autoplay: this.playerOption.autoplay,
        licenseUrl:
          'https://license.vod2.myqcloud.com/license/v2/1301306766_1/v_cube.license',
        sources: sources,
        controlBar: {
          playToggle: false,
          reportable: false,
        },
      })

      this.$nextTick(() => {
        // 监听错误
        this.Player.one('error', (e) => {
          this.Player.errorDisplay.close()
          if (e.data.code == 14) {
            this.$message.error('直播未开始或网络状态不佳，请尝试刷新页面')
          } else {
            console.info(e.data.message || '播放错误：' + e.data.code)
            // this.$message.error(e.data.message || '播放错误：' + e.data.code)
          }
        })

        // 可以播放时记录初始时长
        this.Player.on('canplay', () => {
          this.playStartSec = this.timestamp - this.chapterInfo.start_time
        })

        // 监听开始播放
        this.Player.on('play', () => {
          if (this.playingTimer) {
            clearInterval(this.playingTimer)
            this.playingTimer = null
          }
          this.playingTimer = setInterval(() => {
            if (this.chapterInfo && this.Player) {
              let currentTime = this.playStartSec + this.Player.currentTime()
              this.saveLearnLog(currentTime, true)
            }
          }, 15 * 1000)
        })

        // 监听暂停
        this.Player.on('pause', () => {
          this.Player.play()
        })
      })
    },
    // 销毁播放器
    playerDispose() {
      if (this.Player != null) {
        this.Player.dispose()
        this.Player = null
      }
    },
    /**
     * 存储学习记录
     */
    saveLearnLog(second) {
      if (this.playingSec < 10) return false
      postStudyLearn({
        chapter_id: this.chapter_id,
        second: second,
      })
    },
    // 下拉菜单跳转
    userMenuClick(index) {
      const path = this.userMenu[index].path
      if (typeof path === 'function') {
        path()
      } else {
        this.$router.push(path)
      }
    },
    logout() {
      window.localStorage.removeItem('user-token')
      this.$store.commit('setUser')
      if (this.$route.meta.needLogin) {
        this.$router.push({
          path: '/login',
          query: {
            url: this.$route.fullPath,
          },
        })
      }
    },
  },
}
</script>
<style scoped lang="scss">
.header {
  width: 100%;
  min-width: 1100px;
  height: 80px;
  background: #303135;
  .header-body {
    margin: 0 auto 50px auto;
    height: 100%;
    width: 90%;
    min-width: 1100px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      .course-name {
        color: #fff;
        font-size: 18px;
      }
    }
    .right {
      color: #fff;
      .listed {
        cursor: pointer;
        color: #fff;

        & > div {
          display: flex;
          align-items: center;
          img {
            width: 44px;
            height: 44px;
            display: block;
            border-radius: 50%;
            border: solid 2px #ffffff;
            margin-right: 12px;
          }

          .nickname {
            margin-bottom: 10px;
            font-size: 16px;
          }
        }
      }
    }
  }
}
.pager {
  width: 100%;
  min-width: 1100px;
  height: calc(100vh - 80px);
  background: #27282c;
  padding-top: 60px;

  .pager-body {
    margin: 0 auto 50px auto;
    height: calc(100% - 120px - 50px);
    width: 90%;
    min-width: 1100px;
    display: flex;

    .left {
      flex: 1;
      height: 100%;
      border-radius: 6px;
      margin-right: 42px;
      background: #3d3e42;
      overflow: hidden;

      .player-box {
        width: 100%;
        height: 100%;
        .player-container {
          width: 100%;
          height: 100%;
        }
      }

      .wait {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;

        .daojishi {
          background-color: rgba(255, 255, 255, 0.2);
          border-radius: 8rpx;
          border: 2rpx solid rgba(255, 255, 255, 0.4);
          padding: 8rpx 16rpx;
        }

        .jieshutxt {
          text-align: center;
          margin-bottom: 30rpx;
        }
        .huifang {
          font-size: 26rpx;
          line-height: 56rpx;
          background-color: rgba(255, 255, 255, 0.2);
          color: #fff;
          border: 2rpx solid rgba(255, 255, 255, 0.4);
        }
      }
    }

    .right {
      ::v-deep * {
        &::-webkit-scrollbar {
          width: 10px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background: #2b2a2f;
        }
        &::-webkit-scrollbar-track {
          border-radius: 0;
          background: transparent;
        }
      }

      padding: 7px 7px;
      width: 520px;
      height: 100%;
      background: #3d3e42;
      border-radius: 18px;
      overflow: hidden;

      ::v-deep .tabs {
        margin-bottom: 7px;
        height: 64px;
        padding: 7px 0;
        background: #313236;
        border-radius: 15px;
        color: #fff;
        .el-tabs__header {
          margin: 0;
          height: 100%;
        }
        .el-tabs__item {
          color: #fff;
          z-index: 2;
          outline: none;
          font-size: 20px;
          line-height: 50px;
          height: 50px;
          padding: 0 10px;
        }
        .el-tabs__active-bar {
          height: 100%;
          border-radius: 12px;
          z-index: 1;
          background: #0e78ff;
        }
        .el-tabs__nav-wrap::after {
          display: none;
        }
      }

      .main {
        width: 100%;
        height: calc(100% - 64px - 7px);
        overflow: hidden;
        .main-body {
          height: 100%;
        }
      }

      .jianjie {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        border-radius: 15px;
        .content {
          width: 100%;
          height: 100%;
          ::v-deep img {
            display: block;
            width: 100%;
            height: auto;
          }
        }
      }

      .chatbox {
        width: 100%;
        height: 100%;
        position: relative;
        padding-bottom: 100px;
        .error-msg {
          text-align: center;
          padding-top: 30px;
          color: #7d7d7d;
        }
        .wsmsg-box-out {
          width: 100%;
          height: 100%;
          position: relative;

          .new-msg-num {
            position: absolute;
            bottom: 15px;
            right: 20px;
            padding: 5px 15px;
            background: #fff;
            border: 1px solid #e1ecfa;
            color: #0e79ff;
            font-size: 12px;
            border-radius: 5px;
            &::before {
              position: absolute;
              top: 100%;
              left: 50%;
              content: '';
              margin-left: -4px;
              border-left: 4px solid transparent;
              border-right: 4px solid transparent;
              border-top: 5px solid #fff;
              z-index: 2;
            }
            &::after {
              position: absolute;
              top: 100%;
              left: 50%;
              content: '';
              margin-left: -5px;
              border-left: 5px solid transparent;
              border-right: 5px solid transparent;
              border-top: 6px solid #e1ecfa;
              z-index: 1;
            }
          }
        }
        .wsmsg-box {
          width: 100%;
          height: 100%;
          overflow: hidden;

          .wsmsg-list {
            width: 100%;
            height: 100%;
            padding: 15px;
            overflow-y: auto;

            .wsok-msg {
              text-align: center;
              font-size: 12px;
              padding-bottom: 15px;
              padding-top: 0;
              color: #b1b1b1;
            }
            .item {
              display: flex;
              margin-bottom: 20px;
              .head {
                display: block;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background: #313236;
                flex-shrink: 0;
              }
              .body {
                color: #fff;
                .name {
                  padding: 2px 0 10px 0;
                }
                .content {
                  display: flex;
                  & > div {
                    background-color: #27384c;
                    padding: 8px 13px;
                    font-size: 14px;
                    max-width: 300px;
                    border-radius: 4px;
                    line-height: 1.4;
                  }
                }
              }
              &.l {
                .head {
                  margin-right: 15px;
                }
              }
              &.r {
                flex-direction: row-reverse;
                .head {
                  margin-left: 15px;
                }
                .body {
                  .name {
                    text-align: right;
                  }
                  .content {
                    justify-content: flex-end;
                    & > div {
                      background-color: #313236;
                    }
                  }
                }
              }
            }
          }
        }

        .send-box {
          position: absolute;
          left: 10px;
          bottom: 10px;
          width: calc(100% - 20px);
          background: #2b2a2f;
          padding: 20px 16px;
          display: flex;
          border-radius: 14px;

          .send-input {
            ::v-deep .el-input__inner {
              background: #6b6b6d;
              border: none;
              color: #fff;
            }
          }
          .send-btn {
            margin-left: 10px;
            background: #2873ff;
            color: #fff;
            border: none;
          }
        }
      }
    }
  }
  .bottom {
    height: 120px;
    text-align: center;
    color: #cbcbcb;
    padding-top: 60px;
    font-size: 14px;
    a {
      color: #fff;
    }

    .copytext {
      & > span {
        margin-left: 10px;
      }
    }
  }
}
</style>
